/** Misma regla que backend FR-011. */
export const LONGITUD_MINIMA_PASSWORD = 10

export function passwordValida(p: string): boolean {
    return p.length >= LONGITUD_MINIMA_PASSWORD
}
